export { default } from "ember-power-select/components/power-select/placeholder";
